export default function isElement(node) {
   try {
      return node instanceof Element;
   } catch (e) {
      return !!node.nodeName;
   }
}
